<template>
  <b-modal id="addNewRole" title="Add New Role" @hidden="resetInfoModal" no-close-on-backdrop ok-title="Save" @ok="submitForm" size="xl">
    <b-container class="mt-1">
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col md="3">
              <b-form-group :class="validation ? 'is-valid' : 'is-invalid'" label="Role Name:">
                <validation-provider #default="{ errors }" name="Role Name" rules="required">
                  <b-form-input v-model="role.name" list="input-list" placeholder="Enter Role Name" :state="validation" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="9" style="padding-left: 0px!important">
              <b-form-group :class="validation ? 'is-valid' : 'is-invalid'" label="Role Description:">
                <validation-provider #default="{ errors }" name="Role Description:" rules="required">
                  <b-form-input v-model="role.description" list="input-list" placeholder="Enter Role Description" :state="validationdes" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>


            <b-col cols="12" style="margin-bottom: 1rem;">
              <b-col cols="12">

                <b-tabs vertical nav-wrapper-class="nav-vertical" fill class="tab-class">

                  <b-tab title="Equity&Bond Permissions">
                    <b-table hover responsive :items="p_equity" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>
                  

              <b-tab title="FX Spot&Forward Swap Permissions">
                <b-table hover responsive :items="p_fx" :fields="fields">
                  <template #cell(description)="data">
                    <span>{{ data.item.description }}</span>
                  </template>

                  <template #cell()="data">
                    <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                  </template>
                </b-table>
              </b-tab>

                  <b-tab title="Transfers Permissions">
                    <b-table hover responsive :items="p_transfer" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                

           
          

                  <b-tab title="Accounts Permissions">
                    <b-table hover responsive :items="p_account" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title="Security Permissions">
                    <b-table hover responsive :items="p_security" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title="Journal Permissions">
                    <b-table hover responsive :items="p_journal" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title="Users Permissions">
                    <b-table hover responsive :items="p_user" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title="Future Contracts Permissions">
                    <b-table hover responsive :items="p_future_contract" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title="Fx Options Permissions">
                    <b-table hover responsive :items="p_fx_option" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>


                  <b-tab title="Admin Panel Permissions">
                    <b-table hover responsive :items="p_admin" :fields="fields">
                      <template #cell(description)="data">
                        <span>{{ data.item.description }}</span>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox switch size="sm" class="ml-5" :value="data.item" v-model="selected"> </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>
  </b-modal>
</template>

<script>
import store from '@/store';
import Ripple from 'vue-ripple-directive';
import settingsStoreModule from '../../settingsStoreModule';
import { onUnmounted } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { BTabs, BTab, BCardText } from 'bootstrap-vue';
import { BTable } from 'bootstrap-vue';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BTabs,
    BTab,
    BTable,
  },
  directives: {
    Ripple,
  },
  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = 'settings';

    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME)) store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME)) store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },
  props: ['getRoles', 'loading'],
  data() {
    return {
      fields: [
        { key: 'Description', sortable: false, class: 'text-left w-75', thClass: 'bg-primary text-white' },
        { key: 'Yes/No', sortable: false, class: 'text-center w-25', thClass: 'bg-primary text-white' },
      ],

      required,
      selected: [],
      permissions: [],
      p_equity: [],
      p_fx: [],
      p_fx_option: [],
      p_future_contract: [],
      p_transfer: [],
      p_account: [],
      p_security: [],
      p_journal: [],
      p_admin: [],
      p_user: [],

      role: {
        name: '',
        description: '',
        permissions: '',
      },
      submitted: false,
    };
  },
  methods: {
    submitForm() {
      const self = this;
      this.$emit('loading', true);
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.submitted = true;
          this.$bvModal.hide('addNewRole');
          this.role.permissions = this.selected;
          store.dispatch('settings/addRole', self.role).then((response) => {
            if (response.status == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Successful',
                  text: '✔️ Role Add Successfully',
                  icon: 'ThumbsUpIcon',
                  variant: 'success',
                },
              });
              this.getRoles();
              this.resetInfoModal();
            }
          }); // dispatch store action
        }
      });
    },
    getPermissions() {
      store
        .dispatch('settings/fetchPermissions', [])
        .then((res) => {
          this.permissions = res.data.data;
          res.data.data.forEach((p) => {
            p.group === 'equity' ? this.p_equity.push(p) : '';
            p.group === 'fx' ? this.p_fx.push(p) : '';
            p.group === 'transfer' ? this.p_transfer.push(p) : '';
            p.group === 'account' ? this.p_account.push(p) : '';
            p.group === 'security' ? this.p_security.push(p) : '';
            p.group === 'journal' ? this.p_journal.push(p) : '';
            p.group === 'admin' ? this.p_admin.push(p) : '';
            p.group === 'user' ? this.p_user.push(p) : '';
            p.group === 'fxOptions' ? this.p_fx_option.push(p) : '';
            p.group === 'futureContract' ? this.p_future_contract.push(p) : '';

          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetInfoModal() {
      this.submitted = false;
      this.role.name = '';
      this.role.description = '';
      this.role.permissions = '';
      this.selected = [];
    },
    handleSelected(tr) {
      // this.$vs.notify({
      //   title: `Selected ${tr.username}`,
      //   text: `Email: ${tr.email}`
      // })
    },
  },
  computed: {
    validation() {
      return this.role.name.length > 1;
    },
    validationdes() {
      return this.role.description.length > 1;
    },
  },
  created() {
    this.getPermissions();
  },
};
</script>

<style scoped>
.tab-class >>> .nav-item {
  position: relative;
  display: flex;
  justify-content: start;
}

.tab-class >>> .nav-vertical {
  padding-left: 0 !important;
}

.tab-class >>> .nav-pills .nav-link.active {
  width: 100%;
}
</style>
